export class BaseObject{
	load(obj) {
		let keys = Object.keys(this);
		for (let i = 0; i < keys.length; i++) {
			let key = keys[i];
			if(this.hasOwnProperty(key) && obj.hasOwnProperty(key)) {
				this[key] = obj[key];
			}
		}
		return this;
	}
}

export class BaseEntity extends BaseObject {
	constructor() {
		super();
	}
}

export class BaseSearch {
    page     = 1;
    pageSize = 20;
    sort     = "-id";
    toParams() {
        return {
            sort: this.sort,
            page: this.page,
            page_size: this.pageSize,
        };
    }
}

export class StatusCount {
    //object : {statusKey: count} : {1: 5, 2: 10}
    initByData(object) {
        for (const key in object) {
            if (Object.hasOwnProperty.call(object, key)) {
                this[key] = object[key];
            }
        }
    }
}

export class BaseList extends BaseObject {
    list   = [];
    total  = 0;
    search = new BaseSearch(); // instance of BaseSearch
    constructor(search) {
		super();
		this.search = search;
	}
}
